import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { GetKorisnikTenantAccessResponse } from '@kodit/core/data-api';
import { AuthService } from '@kodit/core/services';
import { colors } from '../topbar/topbar.component';
import { CoreService, TopbarService } from '@kodit/core/core-ui';

@Component({
  selector: 'kodit-sub-expired-topbar',
  templateUrl: './inactive-or-expired-topbar.component.html',
  styleUrls: ['./inactive-or-expired-topbar.component.scss'],
})
export class InactiveOrExpiredTopbarComponent
  implements OnInit, AfterViewInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  jeRegos: boolean = false;
  korisnikTenantAccesses$: Observable<GetKorisnikTenantAccessResponse>;
  name: string;
  email: string;
  topbarUserMenuActive: boolean;

  constructor(
    private _authService: AuthService,
    public _coreService: CoreService,
    private service: TopbarService,
    private _cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._subs.add(
      this._authService.getUserChanged.subscribe((result) => {
        if (result) {
          this._prepareUserInfo();
        }
      })
    );
  }

  private _prepareUserInfo(): void {
    const userData = this._authService.getUserData;
    const element = document.querySelector('.profile-image');
    const height = document.getElementById('avatar-initials')?.offsetHeight;
    this.name = userData.fullName;
    this.email = userData.email;
    const initials =
      userData.fullName.split(' ')[0].charAt(0).toUpperCase() +
      userData.fullName.split(' ')[1].charAt(0).toUpperCase();

    const charIndex = initials.charCodeAt(0) - 65;
    const colorIndex = charIndex % 19;
    const stylle = `background-color: ${colors[colorIndex]};
    border-radius: 10px;
    width: ${height}px;
    height: ${height}px;
    color: #FFF;
    text-align: center;
    line-height: ${height}px;`;

    if (element) {
      element.setAttribute('style', stylle);
      element.innerHTML = initials;
    }

    this.korisnikTenantAccesses$ = this._coreService.getKorisnikTenantAccesses(
      userData.email
    );
  }

  openProfileSidebar() {
    this.service.showProfileSidebar();
  }

  ngAfterViewInit(): void {
    this._prepareUserInfo();
    this._cd.detectChanges();
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
